<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import { formatIndexDate } from '@/helpers/tzDate'
import * as stockReportApi from '@/services/rest-api-sms/lib/stock-report/stock-report'
import * as usersApi from '@/services/rest-api-sms/lib/users/users'

export default {
  page: {
    title: 'Stock Technician',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  mixins: [Helper],

  data() {
    return {
      reportTechnicians: [],
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      totalPages: 0,
      filteredItems: [],
      userId: null,
      filter: null,
      loading: false,
      isDisableApplyBtn: false,
      dateRange: [],
      maxDate: 1,
      pastDate: null,
      futureEnd: moment().add(24, 'hours'),
      isTimeChanged: false,
    }
  },

  computed: {
    title() {
      return 'Stock Technician'
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)
        return this.reportTechnician.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.reportTechnician
      }
    },

    reportTechnician() {
      return [
        {
          key: 'user_name',
          label: this.$t('workOrder.reportTechnician.column.technician'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('workOrder.reportTechnician.column.report'),
          sortable: true,
        },
        {
          key: 'sent_on',
          label: this.$t('workOrder.reportTechnician.column.sentDate'),
          sortable: true,
        },
        {
          key: 'attachment',
          label: this.$t('workOrder.reportTechnician.column.attachment'),
          sortable: true,
        },
      ]
    },

    shortcuts() {
      let startDay = new Date()
      startDay.setHours(0, 0, 0)

      let endDay = new Date()
      endDay.setHours(23, 59, 59)
      return [{ text: 'Hari Ini', onClick: () => [startDay, endDay] }]
    },

    resourcefulQuery() {
      return {
        technicians: async (opts) => {
          let params = {
            search: opts?.search,
            filters: [
              `position_id eq ${process.env.VUE_APP_TECHNICIAN_POSITION_ID}`,
              `company_id eq ${process.env.VUE_APP_TECHNICIAN_COMPANY_ID}`,
            ],
          }
          if (this.userId) {
            params.filters.push(`user_id eq ${this.userId}`)
          }
          const result = await usersApi.getV2(params)
          return result
        },
      }
    },
  },

  async mounted() {
    this.initializeTodayDateRange()
    // Optionally auto-load data with today's date
    this.getReportTechnicians()
  },

  methods: {
    initializeTodayDateRange() {
      let startDay = new Date()
      startDay.setHours(0, 0, 0)

      let endDay = new Date()
      endDay.setHours(23, 59, 59)

      this.dateRange = [startDay, endDay]
    },

    formatIndexDate,

    formatDetailWithLocalTime(detail) {
      const isoDatetimeRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g
      return detail.replace(isoDatetimeRegex, (match) => {
        const formatIdxDate = formatIndexDate(match)
        return formatIdxDate.date + ' ' + formatIdxDate.time
      })
    },

    async applyFilter() {
      this.getReportTechnicians()
    },

    async getReportTechnicians() {
      this.loading = true
      this.isDisableApplyBtn = true

      let filters = [`status eq 'SENT'`]

      if (this.userId) {
        filters.push(`user_id eq ${this.userId}`)
      }

      if (this.dateRange) {
        const dateRange = [
          Helper.methods.momentYmDHms(this.dateRange[0]),
          Helper.methods.momentYmDHms(this.dateRange[1]),
        ]
        filters.push(`sent_on gte '${dateRange[0]}'`)
        filters.push(`sent_on lte '${dateRange[1]}'`)
      }

      let params = {
        page: this.currentPage,
        limit: this.perPage,
        filters: filters,
        sorts: ['sent_on DESC'],
      }

      const response = await stockReportApi.get(params)
      if (!response) {
        this.loading = false
        this.isDisableApplyBtn = false
        return
      }

      this.reportTechnicians = response.data.paginated_result
      this.filteredItems = response.data.paginated_result
      this.totalRows = response.metadata.total_count
      this.currentPage = response.metadata.page
      this.totalPages = response.metadata.total_page

      this.loading = false
      this.isDisableApplyBtn = false
      return response?.data
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.filteredItems = filteredItems
      this.currentPage = 1
    },

    pickDate(date) {
      this.pastDate = new Date(date.getTime() - 24 * this.maxDate * 3600 * 1000)
      this.futureEnd = moment().add(24, 'hours')
    },

    disabledDate: function (date) {
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    disabledTime: function (time) {
      if (this.dateRange.length === 0) return false
      let startRange = new Date(this.dateRange[0])
      const nextTimeDisabled = new Date(startRange.getTime() + 24 * 3600 * 1000)
      return time > nextTimeDisabled
    },

    handleOpenDatePicker(date) {
      if (date[0] === null && date[1] === null) {
        this.dateRange = null
        this.pastDate = null
        this.futureEnd = moment().add(24, 'hours')
        return
      }

      this.currentPage = 1
      date[0].setHours(0, 0, 0)
      date[1].setHours(23, 59, 59)
    },

    customLabelTechnician(item) {
      return `${item.fullname}`
    },

    // Handle attachment download
    downloadAttachment(attachmentUrl) {
      if (!attachmentUrl) {
        return
      }

      // Create a temporary anchor element for download
      const link = document.createElement('a')
      link.href = attachmentUrl
      link.target = '_blank'
      link.download = '' // This will use the filename from the URL

      // Append to body, click, and remove
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    changePage(e) {
      this.currentPage = e
      this.getReportTechnicians()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.perPage = e
      this.getReportTechnicians()
    },
  },
}
</script>

<style>
input.mx-input {
  font-size: small;
}
</style>

<template>
  <div>
    <div class="d-flex col-6 mb-5">
      <div class="pt-0 col-5">
        <label class="align-self-center fw-bold">
          {{ $t('workOrder.reportTechnician.column.sentDate') }}
        </label>
        <date-picker
          v-model="dateRange"
          type="date"
          :placeholder="'Pilih Tanggal'"
          range
          :shortcuts="shortcuts"
          id="mc-datepicker-fuel"
          @pick="pickDate"
          :disabled-date="disabledDate"
          @change="handleOpenDatePicker"
        />
      </div>

      <div class="pt-0 px-2 col-5">
        <label class="align-self-center fw-bold">
          {{ $t('workOrder.reportTechnician.column.technician') }}
        </label>
        <FormulateInput
          type="select-resourceful"
          v-model="userId"
          placeholder="Pilih Teknisi"
          :optionsGetter="resourcefulQuery.technicians"
          :optionLabelFn="
            ({ item }) => {
              return item.fullname
            }
          "
          class="pt-0"
          trackBy="user_id"
          :allow-empty="true"
          :multiple="false"
        />
      </div>

      <div class="pt-0 col-5">
        <label class="align-self-center fw-bold text-white">F</label>
        <div>
          <button :disabled="isDisableApplyBtn" class="btn btn-primary ms-2" @click="applyFilter">
            {{ $t('global.search') }}
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive my-3 border border-1">
      <b-table
        class="datatables"
        :items="reportTechnicians"
        :fields="visibleFields"
        responsive="sm"
        show-empty
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :busy="loading"
      >
        <template #cell(sent_on)="data">
          {{ data.value ? momentDMHms(data.value) : '-' }}
        </template>
        <template #cell(attachment)="data">
          <div v-if="data.value" class="text-center">
            <button
              type="button"
              class="btn btn-primary"
              @click="downloadAttachment(data.value)"
              :title="$t('global.download')"
            >
              <i class="mc-fa icon-fill_excel me-1"></i>
              {{ $t('global.download') }}
            </button>
          </div>
          <div v-else class="text-center text-muted">
            <span class="text-muted">-</span>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            <span>Menampilkan</span>
            <span>
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                @change="resetFilter"
              />
            </span>
            <span>entri.&nbsp;&nbsp;</span>

            <span>
              Menampilkan&nbsp;
              <strong>
                {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
              </strong>
              &nbsp;sampai&nbsp;
              <strong>
                {{
                  currentPage != totalPages
                    ? currentPage * perPage
                    : (currentPage - 1) * perPage + filteredItems.length
                }}
              </strong>
              &nbsp;dari&nbsp;
              <strong>
                {{ totalRows }}
              </strong>
              &nbsp;entri.
            </span>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-if="!loading"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @change="changePage"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
